import { UntypedFormGroup } from '@angular/forms';

export function AmountRangeMustBeValid() {
  return (formGroup: UntypedFormGroup) => {
    const typeControl = formGroup.controls['type'];
    const amountToControl = formGroup.controls['toamount'];
    const amountFromControl = formGroup.controls['fromamount'];
    console.log(`AmountRangeValidator fired: from ${amountFromControl.value} to ${amountToControl.value}`);

    if (amountToControl.errors && !amountToControl.errors.invalidRange) {
      //return if another validator has already found an error
      console.log(`returning amountToControl.errors: ${JSON.stringify(amountToControl.errors)}`);
      return;
    }
    if (typeControl.value === "rng") {
      if (amountToControl.value < amountFromControl.value) {
        amountToControl.setErrors({ invalidRange: true });
      } else {
        amountToControl.setErrors(null);
      }
    }
  }
}
